import { render, staticRenderFns } from "./imgUpload.vue?vue&type=template&id=1c88614b"
import script from "./imgUpload.vue?vue&type=script&lang=js"
export * from "./imgUpload.vue?vue&type=script&lang=js"
import style0 from "./imgUpload.vue?vue&type=style&index=0&id=1c88614b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports